// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2mK5a","title":"Info_title__FFwis","links":"Info_links__uzGzP","link":"Info_link__20cnA","logo":"Info_logo__1RDN8"};